import { Directive, ElementRef, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import * as SimpleMDE from 'simplemde';

import { InnerValueAccessor } from './inner_value_accessor';

export const SIMPLE_MDE_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SimpleMDEDirective),
  multi: true
};

@Directive({
  selector: '[appSimpleMDE]',
  providers: [SIMPLE_MDE_VALUE_ACCESSOR]
})
export class SimpleMDEDirective extends InnerValueAccessor implements OnInit, OnDestroy {
  @Input() options: SimpleMDE.Options;
  @Output() public createMDE = new EventEmitter<SimpleMDE>();

  private _element: any;
  private simplemde: SimpleMDE;

  constructor(_elementRef: ElementRef) {
    super();
    this._element = _elementRef.nativeElement;
  }

  ngOnInit() {
    const options = Object.assign({}, this.options);
    options.element = this._element;

    this.simplemde = new SimpleMDE(options);
    this.createMDE.emit(this.simplemde);

    this.simplemde.codemirror.on('change', () => {
      this.value = this.elementValue;
    });
  }

  ngOnDestroy() {
    this.simplemde.toTextArea();
    this.simplemde = null;
  }

  writeValue(value: any): void {
    super.writeValue(value);
    this.elementValue = this.value;
  }

  get elementValue() {
    return this.simplemde.value();
  }

  set elementValue(value: string) {
    if (value !== null) {
      this.simplemde.value(value);
    }
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/simple-mde/simple-mde.directive.ts